export default __webpack_public_path__ + "static/horizontalDots-cdcccba04a75b8e800d954cf9d3e8b02.svg";